import(/* webpackMode: "eager" */ "/vercel/path0/app/forgot-password/page.tsx");
